<template>
  <div id="main">
    <br />
    <br />
    <font color="red">
      <b>Page Not Found</b>
    </font>
    <br />
    <br />
  </div>
</template>

<script>
export default {
  name: 'main'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/notfound.vue